import React from "react";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../../../../../components/dashboard/dashboardHeader";
import { ChecklistView } from "../../../quality/checklists/checklist";

/**
 * HSE/KS Checklist View - Sjekkliste detaljer (ISO 9001:2015 kap. 8.5)
 */
export const HseKsChecklistView = () => {
  const { t } = useTranslation();

  return (

    <ChecklistView />

  );
};

